import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {

  const lenisCtor = window.Lenis;
  let lenis = null;
  let lenisRafId = null;

  const runLenisRaf = (time) => {
    if (!lenis) {
      return;
    }

    lenis.raf(time);
    lenisRafId = requestAnimationFrame(runLenisRaf);
  };

  const startLenisRaf = () => {
    if (!lenis || lenisRafId !== null) {
      return;
    }

    lenisRafId = requestAnimationFrame(runLenisRaf);
  };

  const stopLenisRaf = () => {
    if (lenisRafId === null) {
      return;
    }

    cancelAnimationFrame(lenisRafId);
    lenisRafId = null;
  };

  if (
    typeof lenisCtor === 'function' &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    lenis = new lenisCtor({
      duration: 1.1,
      smoothWheel: true,
      syncTouch: false,
      wheelMultiplier: 0.9,
      anchors: true,
    });

    document.documentElement.classList.add('has-lenis');
    startLenisRaf();

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopLenisRaf();
      } else {
        startLenisRaf();
      }
    });

    window.addEventListener('pagehide', stopLenisRaf);
    window.addEventListener('pageshow', startLenisRaf);
  }



  const recruitSwiperInstances = [];

  const ensureRecruitAutoplayRunning = () => {
    recruitSwiperInstances.forEach((instance) => {
      if (!instance || instance.destroyed || !instance.autoplay) {
        return;
      }

      if (!instance.autoplay.running) {
        instance.autoplay.start();
      }
    });
  };

  const initMainVisualSwiper = () => {
    const mvSwiper = document.querySelector('.mv_bg_swiper');
    if (!mvSwiper || typeof window.Swiper !== 'function') {
      return;
    }

    if (mvSwiper.dataset.swiperInitialized === 'true') {
      return;
    }

    new window.Swiper(mvSwiper, {
      loop: true,
      speed: 2000,
      allowTouchMove: false,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      },
    });

    mvSwiper.dataset.swiperInitialized = 'true';
  };

  const initRecruitVisualSwiper = () => {
    const recruitSwipers = document.querySelectorAll('.recruit-mv_slider-swiper');
    if (!recruitSwipers.length || typeof window.Swiper !== 'function') {
      return;
    }

    recruitSwipers.forEach((slider) => {
      if (slider.dataset.swiperInitialized === 'true') {
        return;
      }

      const isDownDirection = slider.classList.contains('is-down');

      const swiper = new window.Swiper(slider, {
        direction: 'vertical',
        loop: true,
        speed: 8000,
        slidesPerView: 3,
        spaceBetween: 12,
        allowTouchMove: false,
        watchOverflow: false,
        observer: true,
        observeParents: true,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
          reverseDirection: isDownDirection,
        },
      });

      recruitSwiperInstances.push(swiper);

      slider.dataset.swiperInitialized = 'true';
    });

    ensureRecruitAutoplayRunning();
  };

  const initTab = () => {
    const tabLists = document.querySelectorAll('.js-tab');
    tabLists.forEach((tabWrap) => {
      const items = tabWrap.querySelectorAll('.js-tab__item');
      const panels = tabWrap.querySelectorAll('.js-tab__panel');

      items.forEach((item) => {
        item.addEventListener('click', () => {
          const index = item.dataset.tab;
          items.forEach((el) => el.classList.remove('is-active'));
          panels.forEach((el) => el.classList.remove('is-active'));
          item.classList.add('is-active');
          tabWrap.querySelector(`.js-tab__panel[data-panel="${index}"]`).classList.add('is-active');
        });
      });
    });
  };

  const initHeaderToggle = () => {
    const toggle = document.querySelector('.hd-toggle');
    const header = document.querySelector('.header');
    const links = document.querySelector('.hd_links');

    if (!toggle || !header) {
      return;
    }

    toggle.addEventListener('click', () => {
      header.classList.toggle('is-open');
      if (links) {
        if (header.classList.contains('is-open')) {
          links.style.maxHeight = 'none';
          const h = links.scrollHeight;
          links.style.maxHeight = '0';
          links.getBoundingClientRect(); // reflow を挟んでアニメーション開始
          links.style.maxHeight = h + 'px';
        } else {
          links.style.maxHeight = '0';
        }
      }
    });
  };

  const initContactThanksAutoScroll = () => {
    const bodyClassList = document.body ? document.body.classList : null;
    const isContactThanksPath = /(^|\/)contact-thanks\/?$/.test(window.location.pathname);
    const isContactThanksBodyClass =
      bodyClassList &&
      (bodyClassList.contains('page-contact-thanks') || bodyClassList.contains('page-template-page-contact-thanks'));
    const target = document.querySelector('#content');

    if ((!isContactThanksPath && !isContactThanksBodyClass) || !target) {
      return;
    }

    const scrollToTarget = () => {
      const targetTop = target.getBoundingClientRect().top + window.pageYOffset;
      const minScrollTop = window.innerHeight * 0.7;
      const destination = Math.max(targetTop, minScrollTop);

      if (lenis && typeof lenis.scrollTo === 'function') {
        lenis.scrollTo(destination, { immediate: true, force: true });
        return;
      }

      window.scrollTo({ top: destination, behavior: 'auto' });
    };

    requestAnimationFrame(() => {
      requestAnimationFrame(scrollToTarget);
    });

    window.addEventListener('load', scrollToTarget, { once: true });
  };

  const initIndexTitleTextAnimation = () => {
    const targets = document.querySelectorAll('.index-cmn-title .ja, .index-cmn-title .en');
    if (!targets.length) {
      return;
    }

    const shouldReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    targets.forEach((target) => {
      if (target.dataset.titleSplitInitialized === 'true') {
        return;
      }

      const originalText = target.textContent || '';
      target.dataset.titleSplitInitialized = 'true';

      if (shouldReduceMotion) {
        target.classList.add('is-visible');
        return;
      }

      target.setAttribute('aria-label', originalText.trim());
      target.textContent = '';

      Array.from(originalText).forEach((char, index) => {
        const span = document.createElement('span');
        span.className = 'en-char';
        span.setAttribute('aria-hidden', 'true');
        span.style.transitionDelay = `${index * 70}ms`;

        if (char === ' ') {
          span.classList.add('is-space');
          span.innerHTML = '&nbsp;';
        } else {
          span.textContent = char;
        }

        target.appendChild(span);
      });
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.2,
      }
    );

    targets.forEach((target) => {
      if (!target.classList.contains('is-visible')) {
        observer.observe(target);
      }
    });
  };

  const initIntroductionTitleAnimation = ({ force = false } = {}) => {
    const targets = document.querySelectorAll('.introduction-title');
    if (!targets.length) {
      return;
    }

    const shouldReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    targets.forEach((target) => {
      if (!target.dataset.introOriginalHtml) {
        target.dataset.introOriginalHtml = target.innerHTML;
      }

      if (force) {
        const wasVisible = target.dataset.introShown === 'true';
        target.innerHTML = target.dataset.introOriginalHtml;
        target.dataset.introSplitInitialized = 'false';

        if (wasVisible) {
          // 既に一度表示済みの要素はアニメーションなしで即表示状態へ復帰
          target.classList.add('is-visible');
        } else {
          target.classList.remove('is-visible');
        }
      }

      if (target.dataset.introSplitInitialized === 'true') {
        return;
      }

      target.dataset.introSplitInitialized = 'true';

      if (shouldReduceMotion) {
        target.classList.add('is-visible');
        return;
      }

      const source = document.createElement('div');
      source.innerHTML = target.dataset.introOriginalHtml;

      const originalLabel = source.textContent || '';
      target.setAttribute('aria-label', originalLabel.trim());

      const fragment = document.createDocumentFragment();
      let charIndex = 0;
      const viewportWidth = window.innerWidth;

      const appendCharsFromText = (text) => {
        Array.from(text || '').forEach((char) => {
          if (char === '\n') {
            return;
          }

          const span = document.createElement('span');
          span.className = 'intro-char';
          span.setAttribute('aria-hidden', 'true');
          span.style.transitionDelay = `${charIndex * 50}ms`;

          if (char === ' ') {
            span.classList.add('is-space');
            span.innerHTML = '&nbsp;';
          } else {
            span.textContent = char;
          }

          fragment.appendChild(span);
          charIndex += 1;
        });
      };

      const appendNode = (node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          appendCharsFromText(node.textContent || '');
          return;
        }

        if (node.nodeType === Node.ELEMENT_NODE && node.nodeName === 'BR') {
          const isSpOnlyBreak = node.classList.contains('sp_only');
          const isPcOnlyBreak = node.classList.contains('pc_only');

          if ((isSpOnlyBreak && viewportWidth >= 769) || (isPcOnlyBreak && viewportWidth <= 768)) {
            return;
          }

          const br = document.createElement('br');
          br.className = node.className;
          br.setAttribute('aria-hidden', 'true');
          fragment.appendChild(br);
          return;
        }

        if (node.nodeType === Node.ELEMENT_NODE) {
          const isSpOnlyNode = node.classList.contains('sp_only');
          const isPcOnlyNode = node.classList.contains('pc_only');

          if ((isSpOnlyNode && viewportWidth >= 769) || (isPcOnlyNode && viewportWidth <= 768)) {
            return;
          }

          node.childNodes.forEach((childNode) => {
            appendNode(childNode);
          });
        }
      };

      source.childNodes.forEach((node) => {
        appendNode(node);
      });

      target.textContent = '';
      target.appendChild(fragment);
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.dataset.introShown = 'true';
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.15,
      }
    );

    targets.forEach((target) => {
      if (!target.classList.contains('is-visible')) {
        observer.observe(target);
      }
    });
  };



  let els = document.querySelectorAll('.js-fadeIn');

  function checkFadeIn() {
    let windowHeight = window.innerHeight;

    els.forEach(function(el) {
      if (el.classList.contains('is-scrollIn')) return;

      let rect = el.getBoundingClientRect();

      if (rect.top < windowHeight - 250) {
        el.classList.add('is-scrollIn');
      }
    });
  }

  window.addEventListener('scroll', checkFadeIn);
  window.addEventListener('load', checkFadeIn);


    // 子要素をディレイ付きで表示
  let parents = document.querySelectorAll('.js-fade-parent');

  function checkParentFade() {
    let windowHeight = window.innerHeight;

    parents.forEach(function(parent) {
      if (parent.classList.contains('is-shown')) return;

      let rect = parent.getBoundingClientRect();

      // 親が画面内に入ったら
      if (rect.top < windowHeight - 250) {
        parent.classList.add('is-shown');

        let children = parent.querySelectorAll('.js-fade-child');

        children.forEach(function(child, index) {
          setTimeout(function() {
            child.classList.add('is-scrollIn');
          }, index * 250);
        });
      }
    });
  }

  window.addEventListener('scroll', checkParentFade);
  window.addEventListener('load', checkParentFade);

  pageLoading();
  modalImage();
  initTab();
  initHeaderToggle();
  initContactThanksAutoScroll();
  initIndexTitleTextAnimation();
  initIntroductionTitleAnimation();

  let introTitleResizeTimer = null;
  window.addEventListener('resize', () => {
    if (introTitleResizeTimer) {
      clearTimeout(introTitleResizeTimer);
    }

    introTitleResizeTimer = setTimeout(() => {
      initIntroductionTitleAnimation({ force: true });
    }, 180);
  });

  initMainVisualSwiper();
  initRecruitVisualSwiper();
  window.addEventListener('load', initMainVisualSwiper);
  window.addEventListener('load', initRecruitVisualSwiper);
  window.addEventListener('focus', ensureRecruitAutoplayRunning);
  window.addEventListener('pageshow', ensureRecruitAutoplayRunning);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      ensureRecruitAutoplayRunning();
    }
  });


  if (document.body.classList.contains('contact') ) {
    topValidation();
  }
});

